// Aliases de prefixo -> prefixo DXCC. Fonte unica em shared/prefixAlias.json,
// compartilhada com o backend (ver comentario em src/data/dxcc.js).
import ALIAS_JSON from '../../shared/prefixAlias.json';

export const PREFIX_ALIAS = ALIAS_JSON;
